import React from 'react'
import { notificationListFieldConfig } from './constants'
import { useNotificationListContext } from './Context'
import { DataTool } from '../../DataTool'
import type { DataToolProps } from '../../DataTool/Context'
import { ReadUnreadButton } from './ReadUnreadButton'

export const NotificationListDataTool = ({ searchPlaceHolder, ...props }: DataToolProps) => {
  const { notifications, filterCategory } = useNotificationListContext()

  return (
    <DataTool
      fieldsConfig={notificationListFieldConfig}
      searchPlaceHolder={searchPlaceHolder ?? 'Search notifications'}
      {...notifications}
      {...props}
      filterCategory={filterCategory}
      onSort={null}
      loading={notifications?.loading}
      components={{
        other: ReadUnreadButton,
      }}
    />
  )
}
